import { render } from "./ProtocolDetailHistory.vue?vue&type=template&id=549ba166"
import script from "./ProtocolDetailHistory.vue?vue&type=script&lang=js"
export * from "./ProtocolDetailHistory.vue?vue&type=script&lang=js"

import "./ProtocolDetailHistory.vue?vue&type=style&index=0&id=549ba166&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__